import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useParams } from "react-router-dom";
import ComplimentryService from "../../../Services/QRCodeServices/ComplimentryService/ComplimentryService";
import { Card, CardBody, Col, Row } from "reactstrap";
import { formatDateTime } from "../../../Components/Common/FormatDate";

const DetailComplementry = () => {
  const { id } = useParams();

  const [data, setData] = useState();
  console.log("🚀 ~ DetailComplementry ~ data:", data);
  const fetchDetail = async () => {
    try {
      const response = await ComplimentryService.detail(id);
      setData(response);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchDetail();
  }, [id]);
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          title="Complimentry Detail"
          pageTitle="Complimentry Detail"
          breadcrumbItems={[
            { title: "Back To List ", link: "/complimentry-logs" },
          ]}
        />
      </div>
      <Row className="g-3">
        {data?.map((item, index) => (
          <Col lg={4} md={6} sm={12} key={index}>
            <Card className="shadow-sm border-0 rounded-3 h-100">
              <CardBody>
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="mb-0 text-primary fw-bold">
                    {item?.orderRef}
                  </h6>
                  <small className="text-muted">
                    {formatDateTime(item?.givenOn)}
                  </small>
                </div>

                {/* Product Info */}
                <h6 className="fw-semibold mb-2">{item?.productName}</h6>

                <div className="mb-2">
                  <span className="text-muted">Price: </span>
                  <span className="fw-bold">Rs. {item?.productPrice}</span>
                </div>

                <div className="mb-2">
                  <span className="text-muted">Quantity: </span>
                  <span className="fw-bold">{item?.quantity}</span>
                </div>

                <div className="mb-2">
                  <span className="text-muted">Complimentary Value: </span>
                  <span className="fw-bold text-success">
                    {item?.complimentryValue}
                  </span>
                </div>

                <div className="mb-3">
                  <span className="text-muted">Total Amount: </span>
                  <span className="fw-bold text-danger">
                    Rs. {item?.totalOrderAmount}
                  </span>
                </div>

                {/* Reason / Notes */}
                {item?.reason && (
                  <p className="text-secondary small border-top pt-2 mb-0">
                    <strong>Reason: </strong> {item?.reason}
                  </p>
                )}
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default DetailComplementry;
